import { Seo } from '../../components/seo';
import { CustomerList } from '../../components/customers/customer-list';

function CustomersListPage() {
  return (
    <>
      <Seo title="Manage Users" />
      <div className="px-12 pt-10 pb-[35px]">
        <CustomerList />
      </div>
    </>
  );
}

export default CustomersListPage;
